import { ReportDashboardsFeatureDocument } from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

interface UseReportDashboardsFeatureResult {
  loading: boolean
  enabled: boolean
}

export const useReportDashboardsFeature = (): UseReportDashboardsFeatureResult => {
  const { data, loading } = useQuery(ReportDashboardsFeatureDocument)

  const enabled = Boolean(
    data?.permissions?.contextlessPolicyResolutions?.find(
      (resolution) => resolution.id === 'OpenAi_useReportDashboards'
    )?.can
  )

  return { loading, enabled }
}
